/**
 * @desc 保存首页横幅
 */
import { BannerEntity, BannerForm } from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CreateBannerParameter = BannerForm

const method = 'POST'
const url = '/content/operation/banner'

export const createBannerApi = (
  data?: CreateBannerParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<BannerEntity>({
    method,
    url,
    data,
    ...config
  })
}

createBannerApi.method = method
createBannerApi.url = url
